import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { suspenseOptions } from "@/lib/suspense-query";
import { getGetOrderQueryOptions } from "@/requests/gen/react-query/order";
import OrderCreateForm from "../-form";
import { OrderCrumbs } from "../-crumbs";

export const Route = createFileRoute(
  "/_private/_patient-360/order/$orderId/edit",
)({
  loader: ({ context: { queryClient }, params: { orderId } }) =>
    queryClient.ensureQueryData(getGetOrderQueryOptions(orderId)),
  component: OrderEditPage,
});

function OrderEditPage() {
  const { orderId } = Route.useParams();
  // Fetch the order data
  const { data: order } = useSuspenseQuery(
    suspenseOptions(getGetOrderQueryOptions(orderId)),
  );

  return (
    <div>
      <title>{`Edit Order ${orderId} - Legrande Health Portal`}</title>
      <OrderCrumbs canEdit />

      {/* Order form */}
      <Card>
        <CardHeader>
          <CardTitle>Edit Order</CardTitle>
          <CardDescription>
            Select a doctor and patient to get started.
          </CardDescription>
        </CardHeader>
        <CardContent>
          {/* Wait until the order is loaded */}
          {order && <OrderCreateForm order={order} />}
        </CardContent>
      </Card>
    </div>
  );
}
